import React from "react";
import "./MobileMenu.css";
import ermv from "../../img/ermv.png";
import logo_h from "../../img/logo_stc.svg";
import {closeMenu, tables_link} from "../extras/Actions";

export default class MobileMenu extends React.Component{
    render() {
        return (
            <div className="mobile-menu">
                <button className="close" onClick={closeMenu}>X</button>
                <img src={ermv} alt="" className="top-logo"/>
                <ul>
                    <li>
                        <a href="/"> -¿Por qué el regalo más valioso?- </a>
                    </li>
                    <li>
                        <a href="/gifts"> - Elige qué regalar - </a>
                    </li>
                    <li>
                        <a href="/donors"> - Gracias por sus regalos- </a>
                    </li>
                    <li>
                        <a href={tables_link}> - Haz tu propia mesa - </a>
                    </li>
                    <li>
                        <a href="/cart"> - Carrito de compras - </a>
                    </li>
                </ul>
                <img src={logo_h} alt="" className="bottom-logo"/>
            </div>
        );
    }
}